export enum ORDER_HISTORY_TYPE {
  CREATED_AT = 'created_at',
  DELIVERY_TIME = 'delivery_time'
}
